/**
 * Google's "G" as a monochrome stroke mark — a ring open at the upper right with the bar running
 * in from the right edge. Drawn here rather than pulled from lucide-react: lucide
 * carries no brand glyphs, and the four-colour official mark would put four hexes on a screen the
 * ticket restricts to design tokens. Inheriting `currentColor` keeps it on the button's own text
 * colour in both themes.
 *
 * Same conventions as ShareIcon: `em`-sized by the caller off the button's font-size, aria-hidden
 * since the button already says "Google" in words.
 */
export default function GoogleIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      {/* The mark's own geometry as a single path — the official four-colour build would put four
          hexes on a screen restricted to design tokens. */}
      <path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.344-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z" />
    </svg>
  )
}
